<template>
    <div>
        <app-supervision-activity-header
            >Revisión Herramientas</app-supervision-activity-header
        >
        <b-row>
            <b-col cols="12" md="3">
                <b-btn
                    variant="primary"
                    class="btn-block-xs-only"
                    @click="
                        $bus.$emit('supervision-vehicle-state-form-window.open')
                    "
                    >Crear Novedad Vehicular</b-btn
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-vehicle-state-filters @filter="onFilter" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-vehicle-state-list
                    :table-data="vehicleStates"
                    :on-change-page="onChangePage"
                />
            </b-col>
        </b-row>
        <app-pop-up
            id="supervision-vehicle-state-form-window"
            title="Formulario de novedad vehicular"
        >
            <template v-slot:body>
                <app-vehicle-state-form
                    :clientId="supervisionClient.id"
                    ref="vehicle-state-form"
                    @saveVehicleState="onVehicleStateSaved"
                    @disableBtn="formReady = false"
                    @enableBtn="formReady = true"
                ></app-vehicle-state-form>
            </template>
            <template v-slot:buttons v-if="formReady">
                <b-btn
                    variant="primary"
                    @click="$refs['vehicle-state-form'].saveVehicleState()"
                    ><i class="fa fa-save"></i> Guardar</b-btn
                >
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import appVehicleStateList from '@components/Vigilance/VehiclesReview/VehicleStateList'
import appVehicleStateFilters from '@components/Vigilance/VehiclesReview/VehicleStateFilters'
import appVehicleStateForm from '@components/Vigilance/VehiclesReview/VehicleStateForm'
import appSupervisionActivityHeader from '../SupervisionActivityHeader'
import { mapGetters } from 'vuex'
export default {
    components: {
        appVehicleStateList,
        appVehicleStateFilters,
        appVehicleStateForm,
        appSupervisionActivityHeader,
    },
    data: () => ({
        filters: '',
        vehicleStates: '',
        page: 1,
        sortBy: 'vehicle_states.created_at',
        sortDir: 'desc',
        formReady: true,
    }),
    computed: {
        ...mapGetters(['supervisionClient']),
    },
    methods: {
        onFilter(filter) {
            this.filters = filters
            this.loadVehicleStates()
        },
        async loadVehicleStates() {
            const params = {
                ...this.filters,
                page: this.page,
                sortBy: this.sortBy,
                sortDir: this.sortDir,
                clientId: this.supervisionClient.id,
            }

            const { data } = await repo.get('vehicle-states', params)
            this.vehicleStates = data
        },
        onChangePage(page) {
            this.page = page
            this.loadVehicleStates()
        },
        onVehicleStateSaved() {
            this.$bus.$emit('supervision-vehicle-state-form-window.close')
            this.loadVehicleStates()
        },
    },
    mounted() {
        if (!this.supervisionClient)
            return this.$router.push({ name: 'supervisionIndexPage' })
        this.loadVehicleStates()
    },
}
</script>
